<template>
  <LoaderSpinner v-if="flagLoading" />
  <div
    v-else
    class="w-full h-auto p-5 bg-white rounded-xl border border-slate-200 gap-4"
    :class="isMobileView ? 'flex flex-col' : 'grid grid-cols-2'"
  >
    <div
      class="w-full h-auto bg-white rounded-lg shadow dark:bg-gray-800 p-4 md:p-6"
    >
      <div class="self-stretch flex justify-between items-center">
        <div class="grow shrink basis-0 h-5 flex items-center">
          <div
            class="grow shrink basis-0 h-5 text-neutral-900 text-lg font-semibold font-['Public Sans'] leading-7"
          >
            Completed Tasks By Day
          </div>
        </div>
        <div
          class="pl-3.5 pr-2.5 py-1.5 rounded-lg border border-slate-200 flex justify-center items-center gap-2"
        >
          <div
            class="text-slate-600 text-sm font-normal font-['Public Sans'] leading-snug"
          >
            Weekly
          </div>
        </div>
      </div>
      <div id="chart">
        <apexchart
          type="area"
          height="350"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </div>

    <TasksByDueDateChart />
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import ApexCharts from "vue3-apexcharts";
import LoaderSpinner from "@/components/CircularLoader.vue";
import TasksByDueDateChart from "./TasksByDueDateChart.vue";

export default {
  components: {
    apexchart: ApexCharts,
    LoaderSpinner,
    TasksByDueDateChart,
  },
  setup() {
    const store = useStore();
    const isMobileView = computed(() => store.getters.isMobileView);
    const flagLoading = ref(true);

    const series = ref([
      {
        name: "Completed Tasks",
        data: [0, 0, 0, 0, 0, 0, 0],
      },
    ]);

    const chartOptions = ref({
      chart: {
        type: "area",
        height: 350,
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      labels: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      xaxis: {
        type: "category",
      },
      yaxis: {
        opposite: false,
      },
    });

    onMounted(async () => {
      try {
        const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const params = {
          timezone: userTimezone,
          weekOffset: 0,
        };

        const responseTasks = await store.dispatch("fetchTasksByDay", params);
        if (responseTasks.ok) {
          const tasksByDay = responseTasks.data;
          const daysOfWeek = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ];
          series.value[0].data = daysOfWeek.map((day) => tasksByDay[day] || 0);
        } else {
          console.error("Error fetching tasks by day:", responseTasks.message);
        }
      } catch (error) {
        console.error("Error in onMounted:", error);
      } finally {
        flagLoading.value = false;
      }
    });

    return {
      series,
      chartOptions,
      isMobileView,
      flagLoading,
    };
  },
};
</script>
